import React from "react";
import { ChunkCitation } from "../../generated/core-api";
import { CitationOrgSection } from "./CitationOrgSection";
import styles from "./CitationView.module.css";

type CitationViewProps = {
  citations: ChunkCitation[];
};

type GroupedCitations = {
  [orgKey: string]: {
    orgCategory: string;
    orgId: string;
    documents: {
      [docId: string]: ChunkCitation[];
    };
  };
};

export const CitationView: React.FC<CitationViewProps> = ({ citations }) => {
  if (citations.length === 0) return null;

  // Group citations by org first, then by document ID
  const groupedCitations = citations.reduce<GroupedCitations>(
    (acc, citation) => {
      const orgKey = `${citation.org_category}:${citation.org_id}`;
      if (!acc[orgKey]) {
        acc[orgKey] = {
          orgCategory: citation.org_category,
          orgId: citation.org_id,
          documents: {},
        };
      }

      const docId = citation.doc_id;
      if (!acc[orgKey].documents[docId]) {
        acc[orgKey].documents[docId] = [];
      }

      acc[orgKey].documents[docId].push(citation);
      return acc;
    },
    {}
  );

  return (
    <div className={styles.citationContainer}>
      <h4>Citations</h4>
      <ul className={styles.citationList}>
        {Object.entries(groupedCitations).map(([orgKey, orgData]) => (
          <CitationOrgSection
            key={orgKey}
            orgCategory={orgData.orgCategory}
            orgId={orgData.orgId}
            documents={orgData.documents}
          />
        ))}
      </ul>
    </div>
  );
};
